import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { transitions } from '@sinoui/theme';
var SvgWrapper = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  user-select: none;\n  display: inline-block;\n  font-size: 24px;\n  width: 1em;\n  height: 1em;\n  fill: currentColor;\n  flex-shrink: 0;\n  transition: ", ";\n"], ["\n  user-select: none;\n  display: inline-block;\n  font-size: 24px;\n  width: 1em;\n  height: 1em;\n  fill: currentColor;\n  flex-shrink: 0;\n  transition: ",
    ";\n"])), transitions.create('fill', {
    duration: transitions.duration.shorter,
}));
/**
 * SvgIcon组件，即SVG图标组件。
 *
 * 注意：此组件不直接支持主题定制。因一般不会单独使用svg图标，所以可以在包含svg图标的容器组件中设置主题色即可，如：
 *
 * ```react
 * const IconButton = styled.button`
 *  color: ${props => props.theme.palette[props.color][500]};
 * `;
 *
 * <IconButton color="primary"><SvgIcon><path /></SvgIcon></IconButton>;
 * ```
 */
var SvgIcon = function (_a) {
    var className = _a.className, _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, titleAccess = _a.titleAccess, children = _a.children, props = __rest(_a, ["className", "viewBox", "titleAccess", "children"]);
    return (React.createElement(SvgWrapper, __assign({ className: classNames('sinoui-svg-icon', className), viewBox: viewBox, "aria-hidden": titleAccess ? 'false' : 'true' }, props),
        titleAccess && React.createElement("title", null, titleAccess),
        children));
};
SvgIcon.sinouiName = 'SvgIcon';
export default SvgIcon;
var templateObject_1;
//# sourceMappingURL=SvgIcon.js.map